export default __webpack_public_path__ + "static/media/62.df99eb65.jpg";